import LegalPage, { Section } from "@/components/LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage
      title="Refund Policy"
      metaTitle="AleaEdge Refund Policy"
      metaDescription="When AleaEdge issues refunds for subscriptions and one-time parlay purchases — billing errors, technical failures, and discretionary review."
      canonical="/refund-policy"
      intro="We want every member to feel good about their AleaEdge experience. This policy explains when refunds are typically available for subscriptions and one-time digital purchases."
    >
      <Section title="1. Digital Subscriptions">
        <p>AleaEdge subscriptions deliver immediate, ongoing access to picks and analysis. Because content is digital and consumed continuously, subscription fees are generally non-refundable once the billing period has begun. You can cancel at any time to prevent future charges, and you keep access through the end of the period you've already paid for.</p>
      </Section>

      <Section title="2. One-Time Parlay Purchases">
        <p>Parlay drops are delivered instantly upon purchase. Once a parlay has been unlocked or viewed, it is generally not eligible for a refund. The outcome of a parlay does not change refund eligibility — wins and losses are part of sports betting.</p>
      </Section>

      <Section title="3. When We Will Issue a Refund">
        <p>We will review and, where appropriate, refund charges in the following situations:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><span className="text-foreground font-medium">Duplicate or accidental charges</span> caused by a billing error.</li>
          <li><span className="text-foreground font-medium">Unauthorized charges</span> made without your consent — please also notify your card issuer.</li>
          <li><span className="text-foreground font-medium">Failed technical delivery</span> where a purchased parlay or subscription benefit could not be accessed for reasons on our side and the issue could not be resolved.</li>
          <li><span className="text-foreground font-medium">Renewals charged in clear error</span> — for example, a charge processed within a short window after a documented cancellation request.</li>
        </ul>
      </Section>

      <Section title="4. How to Request a Refund">
        <p>Email <a href="mailto:support@aleaedge.com" className="text-primary hover:underline">support@aleaedge.com</a> with your account email, the date and amount of the charge, and a brief description of what happened. We aim to respond within 2 business days. Approved refunds are issued to the original payment method via Stripe and typically appear within 5–10 business days.</p>
      </Section>

      <Section title="5. Discretionary Review">
        <p>We review every request individually and reserve the right to grant goodwill refunds outside of these categories on a case-by-case basis. We also reserve the right to decline refunds in cases of suspected abuse, chargeback fraud, or repeated request patterns.</p>
      </Section>

      <Section title="6. Cancellations">
        <p>Cancelling your subscription stops future charges but does not, by itself, refund the current period. To cancel, open your account and use the billing portal — cancellation is immediate, and access continues through the end of the period you've already paid for.</p>
      </Section>

      <Section title="7. Chargebacks">
        <p>If you have a problem with a charge, please contact us first — we can almost always resolve it faster than your bank can. Filing a chargeback without first contacting support may result in your account being suspended pending review.</p>
      </Section>

      <Section title="8. Contact">
        <p>Refund questions: <a href="mailto:support@aleaedge.com" className="text-primary hover:underline">support@aleaedge.com</a>.</p>
      </Section>
    </LegalPage>
  );
}
